import React from 'react';
export function WhatsAppButton() {
  return;
}